import { useTheme, useMediaQuery } from '@mui/material';
import DocumentoDetailPageDesktop from './DocumentoDetailPageDesktop';
import DocumentoDetailPageMobile from './DocumentoDetailPageMobile';

export default function DocumentoDetailPage() {
  const theme = useTheme();
  const isMobile =useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <DocumentoDetailPageMobile />
    : <DocumentoDetailPageDesktop />;
}